module.exports = __webpack_public_path__ + "img/big_1_50.975cd00a.png";